export default __webpack_public_path__ + "static/media/6.ea179387.jpg";